// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h5[data-v-29aa7330] {\n  font-weight: normal;\n  margin-bottom: 1rem;\n}\n.tab-nav[data-v-29aa7330] {\n  margin-bottom: 1rem;\n}\n.nav-tabs-sm .nav-link[data-v-29aa7330] {\n  padding-top: 0;\n}\n.nav-link[data-v-29aa7330] {\n  padding-bottom: 5px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
